import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import ServiceAppRouter from "./AppRouter";
import { lightTheme, darkTheme, ColorModeContext } from "./theme/defaultTheme";
import {clarity} from "clarity-js";
import './index.css';

clarity.start({
    projectId: process.env.REACT_APP_CLARITY_PROJECT_ID as string,
    upload: 'https://m.clarity.ms/collect',
    track: true,
    content: true,
});
clarity.set('environment', process.env.REACT_APP_ENV as string);
clarity.consent();


function Root(): JSX.Element {
    const [mode, setMode] = React.useState<'dark' | 'light'>(() =>
        (localStorage.getItem('utils-theme') as 'dark' | 'light') || 'dark'
    );

    React.useEffect(() => {
        document.documentElement.style.colorScheme = mode;
    }, [mode]);

    const toggleMode = () => {
        setMode((prev) => {
            const next = prev === 'dark' ? 'light' : 'dark';
            localStorage.setItem('utils-theme', next);
            return next;
        });
    };

    return (
        <ColorModeContext.Provider value={{ toggleMode }}>
            <ThemeProvider theme={mode === 'dark' ? darkTheme : lightTheme}>
                <CssBaseline />
                <ServiceAppRouter />
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Root />
);

// TODO : Test Code 추가
